export type RequestGuard = (request: { method: string; url: URL }) => boolean;

export const READ_ONLY_BLOCKED_HEADER = "x-9am-read-only";

let activeGuard: RequestGuard | undefined;

/**
 * Lets the app veto outgoing 9am API requests (e.g. the read-only "assume
 * identity" mode). Shared by the patched fetch and the XHR file upload, which
 * bypasses fetch.
 */
export const setRequestGuard = (guard: RequestGuard | undefined): void => {
  activeGuard = guard;
};

export const isRequestBlocked = (
  method: string | undefined,
  url: string | URL
): boolean => {
  if (!activeGuard) {
    return false;
  }
  return !activeGuard({
    method: (method ?? "GET").toUpperCase(),
    url: new URL(url)
  });
};

/** 403 so callers take their normal error path; it never triggers a token refresh. */
export const createBlockedRequestResponse = (): Response =>
  new Response(
    JSON.stringify({ message: "Request blocked: read-only mode is active" }),
    {
      status: 403,
      statusText: "Forbidden",
      headers: {
        "content-type": "application/json",
        [READ_ONLY_BLOCKED_HEADER]: "blocked"
      }
    }
  );
